import type { ApiClient } from "../api-client";
import type { EmailPreferencesPatch, EmailPreferencesResponse } from "../types/email";

// GET/PATCH /account/email-preferences (packages/api/src/routes/email-preferences.ts).

export function fetchEmailPreferences(client: ApiClient): Promise<EmailPreferencesResponse> {
  return client.get("/account/email-preferences");
}

export function updateEmailPreferences(
  client: ApiClient,
  patch: EmailPreferencesPatch,
): Promise<EmailPreferencesResponse> {
  return client.patch("/account/email-preferences", patch);
}
